import Behavior from '../behavior';
export declare const server: (serv: Server) => void;
export declare const entity: (entity: any) => void;
declare global {
    interface Server {
        behavior: ReturnType<typeof Behavior>;
    }
    interface Entity {
        behavior: ReturnType<typeof Behavior>;
    }
}
